module.exports = __webpack_public_path__ + "img/bumper.0a5e7544.jpg";